import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import styles from '../css/MultiRangeSlider.module.css';

const MultiRangeSlider = ({ min, max, rangeMin, rangeMax, setRangeMin, setRangeMax, onChange }) => {
  let minValRef = rangeMin;
  let maxValRef = rangeMax;

  const range = useRef(null);

  // Convert to percentage
  const getPercent = (value) => {
  	return Math.round(((value - min) / (max - min)) * 100);
  };

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(rangeMin);
    const maxPercent = getPercent(maxValRef);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;

	  if (maxPercent > 100) {
		range.current.style.width = `100%`;
	  } else {
		range.current.style.width = `${maxPercent - minPercent}%`;
	  }
      
    }
  }, [rangeMin, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef);
    const maxPercent = getPercent(rangeMax);

    if (range.current) {
		if (maxPercent > 100) {
			range.current.style.width = `100%`;
		} else {
			range.current.style.width = `${maxPercent - minPercent}%`;
		}
    }
  }, [rangeMax, getPercent]);

  // Get min and max values when their state changes
  useEffect(() => {
    onChange({ min: rangeMin, max: rangeMax });
  }, [rangeMin, rangeMax, onChange]);

  const numberWithCommas = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const handleMinSlider = (e, value) => {
    e.preventDefault();
    setRangeMin(value);
    minValRef = value;
  }

  const handleMaxSlider = (e, value) => {
    e.preventDefault();
    setRangeMax(value);
    maxValRef = value;
  }

  return (
    <div className={styles.container}>
      <input
        type="range"
        min={min}
        max={max}
        value={rangeMin}
		step={10}
        onChange={(e) => {handleMinSlider(e, Math.min(Number(e.target.value), max - 10))}}
        className={`${styles.thumb} ${styles.thumb_left}`}
        style={{ zIndex: rangeMin > max - 100 && "5" }}
      />
      <input
        type="range"
        min={min}
        max={max}
		step={10}
        value={rangeMax}
        onChange={(e) => {handleMaxSlider(e, Math.max(Number(e.target.value), min + 10))}}
        className={`${styles.thumb} ${styles.thumb_right}`}
      />

      <div className={styles.slider}>
        <div className={styles.slider__track} />
        <div ref={range} className={styles.slider__range} />
		<div className={styles.slider__left_value}>{numberWithCommas(rangeMin)}</div>
		<div className={styles.slider__right_value}>{numberWithCommas(rangeMax)}</div>
      </div>
    </div>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MultiRangeSlider;
